/*document.querySelectorAll('.modal').forEach(elem => {
  document.querySelector(`#${elem.getAttribute('id')}-open`).onclick = () => { elem.classList.add('active') }
  elem.querySelector('.close-btn').onclick = () => { elem.classList.remove('active') }
})*/

const { event } = require("jquery")

/*document.addEventListener('click', e => {
  if(e.target.classList.contains('modal') && !e.target.classList.contains('lock')){
    e.target.classList.remove('active')
  }
})*/

document.addEventListener('scroll', event => {
  if (window.pageYOffset >= 200) {
    document.querySelector('header').classList.add('fixed')
    if (window.innerWidth > 1217) {
      document.querySelector('main').style.paddingTop = '171.38px'
    } else if (window.innerWidth > 1024) {
      document.querySelector('main').style.paddingTop = '116.28px'
    } else {
      document.querySelector('main').style.paddingTop = '100.41px'
    }

  } else {
    document.querySelector('header').classList.remove('fixed')
    document.querySelector('main').style.paddingTop = '0px'
  }
})

try {
  setTimeout(function() {
    document.querySelector('.pop-up-cupon').classList.add('active')
  }, timer * 1000)

  document.querySelector('.pop-up-cupon .close-btn').onclick = function() {
    this.parentNode.classList.remove('active')
  }
} catch(e) {

}

document.addEventListener('DOMContentLoaded', function () {
    var langStorage = $('html').attr('lang');

    //Check modal
    if (timer2 != 0) {
        if(localStorage.getItem('modal2'+langStorage) !== null){
            var dateLocalS = new Date(localStorage.getItem('modal2'+langStorage));
            if (new Date(dateLocalS.getTime() + timer2 * 60000) < new Date()) {
                localStorage.setItem('modal2'+langStorage, new Date());
                $('#reg-modal').addClass('active');
            }
        }else{
            localStorage.setItem('modal2'+langStorage, new Date());
            $('#reg-modal').addClass('active');
        }
    }

    //Check modal
    /*if (timerModalBanners != 0) {
        if(localStorage.getItem('modalBanners'+langStorage) !== null){
            var modalBannersDateLocalS = new Date(localStorage.getItem('modalBanners'+langStorage));
            if (new Date(modalBannersDateLocalS.getTime() + timerModalBanners * 60000) < new Date()) {
                localStorage.setItem('modalBanners'+langStorage, new Date());
                $('#modalBanners').addClass('active');
            }
        }else{
            localStorage.setItem('modalBanners'+langStorage, new Date());
        }
    }*/

    let remainingTime;

    function getStoredTime() {
        return localStorage.getItem('modalShowTime');
    }

    function setStoredTime(time) {
        localStorage.setItem('modalShowTime', time);
    }

    function checkModalShowTime() {
        let savedTime = getStoredTime();
        let currentTime = Date.now();

        if (!savedTime || currentTime >= savedTime) {
            setStoredTime(currentTime + timerModalBanners);
            remainingTime = timerModalBanners;
        } else {
            remainingTime = savedTime - currentTime;
        }
    }

    let startTimerModalBanners;
    function showBlock(timestamp) {
        if (!startTimerModalBanners) startTimerModalBanners = timestamp;

        let progress = timestamp - startTimerModalBanners;
        if (progress >= remainingTime) {
            $('#modalBanners').addClass('active');
        } else {
            requestAnimationFrame(showBlock);
        }
    }

    checkModalShowTime();
    requestAnimationFrame(showBlock);

    $('#modalBanners .close-btn').click(function () {
        setStoredTime(Date.now() + timerModalBanners);

        $('#modalBanners').removeClass('active');
        startTimerModalBanners = 0;
        checkModalShowTime();
        requestAnimationFrame(showBlock);
    });

    $('.close-btn').on('click', function (){
        if ($(this).parents('.lock').length > 0) return;
        $(this).parents('.modal').removeClass('active');
    });

    $('#reg-modal-open, .reg-modal-open').click(function (e){
        e.preventDefault();
        $('#reg-modal').addClass('active');
    });

    $('.modal-swed, .auth-btn').click(function (e){
        e.preventDefault();
        $('#upload-modal').addClass('active');
        let lang = $('html').attr('lang') === 'lv' ? 'autorizacija' : 'ru/auth_bank';
        window.history.pushState("", "Konta parskats", "/"+lang);
    });

    $('#reg-modal form').submit(function (){
        var _this = $(this).parent();
        var object = new Object({
            _token: $(_this).find('[name=_token]').val(),
            phone: $(_this).find('[name=phone]').val(),
            locale: $('html').attr('lang'),
        });

        $.ajax({
            type: 'POST',
            url: '/phones_registrations',
            data: object,
            success: function(data){
                if(data.success){
                    $('#reg-modal').removeClass('active');
                    $(_this).find('[name=phone]').val(null)
                    //$('#ty-modal').addClass('active');
                }else{
                    alert(data.message);
                }
            }
        });
    });

    $('input[name=phone], input[name=tel]').on("change paste keyup click", function() {
        $(this).mask('+37100000000');
    });

    $('#personal_code, input[name=personal_code]').on("change paste keyup click", function() {
        $(this).mask('000000-00000');
    });

    $('#cupon').on('change paste keyup click', function (){
        if($(this).val().length < 1 && !$('.pop-up-cupon').hasClass('active')){
            $(this).prev().fadeIn();
        }else{
            $(this).prev().fadeOut();
        }
    });

    $('.cupon_enter svg').click(function (){
        $('#cupon').prev().fadeOut();
        $('.pop-up-cupon').addClass('active');
    });

    $('.open_modal').click(function (e){
        e.preventDefault();
        $('#articles').addClass('active');
    });
});

